import { DataLayer } from '@grandvisionhq/analytics';

const RX_SUN_CONFIG_EVENT = 'RxSunConfigEvent';
const triggerDataLayerEvent = (eventAction, options)=>{
    const { isWithRx  } = options;
    DataLayer.pushEvent({
        event: RX_SUN_CONFIG_EVENT,
        eventAction,
        eventLabel: isWithRx ? 'prescription lenses' : 'non-prescription lenses'
    });
};

export { triggerDataLayerEvent };
//# sourceMappingURL=data-layer-utils.js.map
